import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BASE_URL, HOSTNAME, generateRandomId } from "@src/utils";
import { weddingHallContract } from "@src/@slice/weddingHallContractSlice";
import { postZeroDepositPayment } from "@src/api/weddingHall/weddingHall";
import { useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";

export default function Ksnet({ name = "결제하기", paymentMethod, autoTrigger = false }) {
  const navigate = useNavigate();
  const userData = useSelector(weddingHallContract).data.user;
  const contractData = useSelector(weddingHallContract).data.weddingContractData;
  const storeId = "2001107229"; // ksnet에서 발급받은 상점아이디, 테스트용 상점 아이디 = 2999199999, 웨딩북용 상점 아이디 = 2001107229
  const paymethod = paymentMethod === "card" ? "1000000000000" : "0010000000000"; // 신용카드 = 1000000000000, 계좌이체 = 0010000000000
  const orderId = generateRandomId("euc-kr"); // 주문번호 - 프론트에서 난수 생성, ksnet 자체에서 euc-kr 기준 30Byte(한글 15자) 제한.
  const accessToken = localStorage.getItem("accessToken"); // 사용자 로그인 access token
  const productName = contractData.partnerName + " " + contractData.individualHallName; // 상품명
  const price = contractData.deposit; // 결제금액
  const customerName = userData.contractor; // 주문자명
  const successRedirectUrl = `${HOSTNAME}/ksnet/payment-success`; // 결제 성공 시 리다이렉트 URL
  const failRedirectUrl = `${HOSTNAME}/ksnet/payment-fail`; // 결제 실패 시 리다이렉트 URL

  function submit(_frm) {
    // 엔드포인트 ex) {BASE_URL}/v3/book/20240729/halls/weddings/contracts/kspay?successRedirectUrl={}&failRedirectUrl={}
    _frm.sndReply.value = `${BASE_URL}/v3/book/20240729/halls/weddings/contracts/kspay?successRedirectUrl=${successRedirectUrl}&failRedirectUrl=${failRedirectUrl}`;
    _frm.action = "https://kspay.ksnet.to/store/KSPayMobileV1.4/KSPayPWeb.jsp";
    _frm.submit();
  }

  useEffect(() => {
    if (autoTrigger) {
      // 컴포넌트가 마운트되면 자동으로 결제 실행
      setTimeout(() => {
        handleSubmit();
      }, 100);
    }
  }, [autoTrigger]);

  const handleSubmit = () => {
    // 결제금액이 0원일 경우 결제 진행하지 않음
    if (price === 0) {
      console.log("결제금액이 0원입니다.");
      postZeroDepositPayment(
        contractData.individualHallId,
        contractData.weddingDate.replaceAll(".", "-"),
        contractData.weddingTime,
        userData.contractor,
        userData.contractorTel,
        userData.contractorEmail,
        userData.contractorZipcode,
        userData.contractorAddress1,
        userData.contractorAddress2,
        userData.brideName,
        userData.brideTel,
        userData.groomName,
        userData.groomTel,
        price,
        price,
      )
        .then((res: AxiosResponse<{ item: string }>) => {
          // res.data.item
          const contractUuid = res.data.item;
          navigate(`/ksnet/payment-success?uuid=${contractUuid}`, { replace: true });
        })
        .catch(() => alert("결제에 실패했습니다."));
    } else {
      // 결제금액이 0원이 아닐경우 pg사 결제 진행
      submit((document as any).KSPayWeb);
    }
  };

  return (
    <div className="btn-wrap">
      <button className={`btn btn-full bold btn-red500`} onClick={handleSubmit}>
        {name}
      </button>
      <div style={{ display: "none" }}>
        <form name="KSPayWeb" method="post">
          <table width="560">
            <tr>
              <td align="center">
                <table width="400">
                  <tr>
                    <td width="290">
                      <input type="text" name="sndPaymethod" value={paymethod} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">상점아이디</td>
                    <td width="290">
                      <input type="text" name="sndStoreid" value={storeId} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">주문번호</td>
                    <td width="290">
                      <input type="text" name="sndOrdernumber" value={orderId} />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td align="center">
                <table>
                  <tr>
                    <td width="110">상품명</td>
                    <td width="290">
                      <input type="text" name="sndGoodname" value={productName} />
                    </td>
                  </tr>
                  <tr>
                    <td height="1"></td>
                  </tr>
                  <tr>
                    <td width="110">금액</td>
                    <td width="290">
                      <input type="text" name="sndAmount" value={price} />
                    </td>
                  </tr>
                  <tr>
                    <td height="1"></td>
                  </tr>
                  <tr>
                    <td width="110">주문자명</td>
                    <td width="290">
                      <input type="text" name="sndOrdername" value={customerName} />
                    </td>
                  </tr>
                  {/* 여기서부터 웨딩홀 계약금 결제 시 보낼 데이터 */}
                  <tr>
                    <td width="110">보증금</td>
                    <td width="290">
                      <input type="text" name="ECH_DEPOSIT" value={price} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">결제아이디</td>
                    <td width="290">
                      <input type="text" name="ECH_PAYMENT_ORDER_ID" value={orderId} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">토큰</td>
                    <td width="290">
                      <input type="text" name="ECH_JWT_TOKEN" value={`bearer ${accessToken}`} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">결제금액</td>
                    <td width="290">
                      <input type="text" name="ECH_PAYMENT_AMOUNT" value={price} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">홀아이디</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_INDIVIDUAL_HALL_ID"
                        value={contractData.individualHallId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">예식날짜</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_WEDDING_DATE"
                        value={contractData.weddingDate.replaceAll(".", "-")}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">예식시간</td>
                    <td width="290">
                      <input type="text" name="ECH_WEDDING_TIME" value={contractData.weddingTime} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">계약자이름</td>
                    <td width="290">
                      <input type="text" name="ECH_CONTRACTOR" value={userData.contractor} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">계약자전화번호</td>
                    <td width="290">
                      <input type="text" name="ECH_CONTRACTOR_TEL" value={userData.contractorTel} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">계약자이메일</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_CONTRACTOR_EMAIL"
                        value={userData.contractorEmail}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">우편번호</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_CONTRACTOR_ZIPCODE"
                        value={userData.contractorZipcode}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">주소</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_CONTRACTOR_ADDRESS1"
                        value={userData.contractorAddress1}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">상세주소</td>
                    <td width="290">
                      <input
                        type="text"
                        name="ECH_CONTRACTOR_ADDRESS2"
                        value={userData.contractorAddress2}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">신부이름</td>
                    <td width="290">
                      <input type="text" name="ECH_BRIDE_NAME" value={userData.brideName} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">신부전화번호</td>
                    <td width="290">
                      <input type="text" name="ECH_BRIDE_TEL" value={userData.brideTel} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">신랑이름</td>
                    <td width="290">
                      <input type="text" name="ECH_GROOM_NAME" value={userData.groomName} />
                    </td>
                  </tr>
                  <tr>
                    <td width="110">신랑전화번호</td>
                    <td width="290">
                      <input type="text" name="ECH_GROOM_TEL" value={userData.groomTel} />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <input type="hidden" name="sndReply" value="" />
          <input type="hidden" name="sndCharSet" value="UTF-8" />
          <input type="hidden" name="sndGoodType" value="1" />
          {/* 간편결제 사용 유무 */}
          <input type="hidden" name="sndQpayType" value="0000000000000" />
          <input type="hidden" name="sndShowcard" value="C" />

          <input type="hidden" name="sndCurrencytype" value="WON" />
          <input type="hidden" name="iframeYn" value="Y" />

          <input type="hidden" name="sndInstallmenttype" value="ALL(0:2:3:4:5:6:7:8:9:10:11:12)" />

          <input type="hidden" name="sndInteresttype" value="NONE" />

          <input type="hidden" name="reCommConId" value="" />
          <input type="hidden" name="reCommType" value="" />
          <input type="hidden" name="reHash" value="" />

          <input type="hidden" name="a" value="a1" />
          <input type="hidden" name="b" value="b1" />
          <input type="hidden" name="c" value="c1" />
          <input type="hidden" name="d" value="d1" />
        </form>
      </div>
    </div>
  );
}
